var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M6 .5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M6 5a.5.5 0 0 1 .5.5v2.75a.5.5 0 0 1-1 0V5.5A.5.5 0 0 1 6 5m.65-1.5a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0",
    clipRule: "evenodd"
  })));
};
export default SvgInfo;